import { type UseQueryResult, useQuery } from 'react-query';
import { TermsAndConditionsService } from '@wealthlane/api-services/wealthlane-customer-service';
// eslint-disable-next-line camelcase
import {
  VendorTermsAndConditionsService,
  type Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetVendorTermAndConditions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto[] | undefined,
  unknown
> => {
  const vendorTermAndConditionList = useQuery(
    ['getVendorTermAndConditionList'],
    async () => {
      return await handleRequest(
        VendorTermsAndConditionsService.getApiCustomerApiVendorTermsAndConditions()
      );
    },
    {
      keepPreviousData: true,
    }
  );

  return vendorTermAndConditionList;
};

export default useGetVendorTermAndConditions;
